import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router";

import { clearCache, updateUserLocal } from "../actions/user";

import Login from "../pages/Login";
import { Modal, ModalBody } from "../components/Modal";
import { getIsSomeObjectPending } from "../selectors/sync";

export default function LoginModalService() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const hasPendingChanges = useSelector((state) =>
    getIsSomeObjectPending(state)
  );

  useEffect(() => {
    if (!hasPendingChanges) {
      dispatch(updateUserLocal({ isAuthenticated: false }));
      dispatch(clearCache());
    }
  }, [hasPendingChanges, dispatch]);

  if (hasPendingChanges) {
    return (
      <Modal isOpened={true} onClose={() => {}}>
        <ModalBody>
          <Login userEmail={user.email} source="fromLoginModal" />
        </ModalBody>
      </Modal>
    );
  }
  return <Redirect to="/sign-in"></Redirect>;
}
